import React from 'react'
import styled from 'styled-components'

const providerImages = {
  visa: require('images/mock-cards/visa.svg'),
  mastercard: require('images/mock-cards/mastercard.svg')
}

const CardWrapper = styled.div`
  position: relative;
  width: ${props => props.size}px;
  border-radius: ${props => props.size / 10}px;
  box-shadow: 0 ${props => props.size / 10}px ${props => props.size / 5}px
    rgba(0, 0, 0, 0.3);
  overflow: hidden;
  padding: 0;
`
const MockCard = ({ provider, size, children, ...rest }) => {
  const imageSource = providerImages[provider || 'visa']
  const finalSize = size || 32
  return (
    <CardWrapper size={finalSize} {...rest}>
      <img
        alt="credit card graphical representation"
        src={imageSource}
        style={{ display: 'block', width: '100%', margin: 0, padding: 0 }}
      />
      <div
        style={{
          position: 'absolute',
          top: finalSize / 8,
          left: 4,
          right: 4,
          fontSize: finalSize / 6,
          fontWeight: 500,
          color: '#f0f0f0',
          textAlign: 'center'
        }}
      >
        {children}
      </div>
    </CardWrapper>
  )
}

export default MockCard
